import MatchUtil from "./../utils/match.util";

const {
  MatchList,
  FAVORITE_STORAGE_KEYS,
  ALL_COMPANY_ROW,
  FETCH_STATUS
} = MatchUtil;

const { MATCH_FILTER_KEYS } = MatchList;

export default {
  lastFetchTime: null,
  activeFetchTimeout: 60 * 1000,
  nonActiveFetchTimeout: 5 * 60 * 1000,
  fetchStatus: FETCH_STATUS.NON_ACTIVE,
  sort: {
    type: null,
    order: null
  },
  filters: [
    MATCH_FILTER_KEYS.ALL,
    { type: MATCH_FILTER_KEYS.COMPANY, value: ALL_COMPANY_ROW._id },
    { type: MATCH_FILTER_KEYS.CHANGES_ONLY, value: false }
  ],
  matches: [],
  expanded: [],
  companies: [],
  searchText: "",
  count: 0,
};
